import React, { useEffect, useState } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { isMobileResolution, isTabletResolution } from "../../utils/WindowWidth"
import { getValidLocaleCode } from "@utils/localisation"
import { generateTableData } from "./helpers"
import { TableFilters } from "./TableFilters"
import { TableRender } from "./TableRender"
import MetaButton from "@components/MetaButton"

import { AVAILABLE_RANGES } from "./TableFilters/index"

export default ({
  calculatedPrices,
  theme = "white-bg",
  defaultRange = "daily",
  pageSize = 10,
  mobileMenuAnchorEl,
  mobileMenuOpen,
  onMobileMenuClose,
  locale,
  localStoragePrefix,
}) => {
  const { t } = useTranslation()

  const [activeVisibleRows, setActiveVisibleRows] = useState(pageSize)
  const [visibleRows, setVisibleRows] = useState(
    AVAILABLE_RANGES.map(r => pageSize)
  )
  const [moreRowsAvailable, setMoreRowsAvailable] = useState(
    AVAILABLE_RANGES.map(
      r => calculatedPrices.priceList[r.id].length - pageSize
    )
  )

  const [range, setRange] = useState(defaultRange)
  const [rangeIdx, setRangeIdx] = useState(0)

  const [currency, setCurrency] = useState(calculatedPrices.defaultCurrency)
  const [tableData, setTableData] = useState(
    generateTableData(
      range,
      currency,
      calculatedPrices,
      visibleRows[rangeIdx],
      t,
      locale
    )
  )

  // Update the table data with all the selected filters
  useEffect(() => {
    const newTableData = generateTableData(
      range,
      currency,
      calculatedPrices,
      visibleRows[rangeIdx],
      t,
      locale
    )
    setTableData(newTableData)
  }, [activeVisibleRows, rangeIdx, range, currency])

  useEffect(() => {
    moreRowsAvailable[rangeIdx] =
      calculatedPrices.priceList[range].length - visibleRows[rangeIdx]
    setMoreRowsAvailable(moreRowsAvailable)
  }, [rangeIdx])

  const selectCurrency = id => {
    setCurrency(id)
  }

  const selectRange = id => {
    setRange(id)
    const newIdx = AVAILABLE_RANGES.findIndex(r => r.id === id)
    setRangeIdx(newIdx)
    setActiveVisibleRows(visibleRows[newIdx])
  }

  const showMore = () => {
    if (moreRowsAvailable[rangeIdx] > 0) {
      visibleRows[rangeIdx] += pageSize
      setVisibleRows(visibleRows)
      setActiveVisibleRows(visibleRows[rangeIdx])
      moreRowsAvailable[rangeIdx] -= pageSize
      setMoreRowsAvailable(moreRowsAvailable)
    }
  }

  return (
    <div className="md:bg-white">
      <TableFilters
        selectCurrency={selectCurrency}
        selectRange={selectRange}
        availableCurrencies={calculatedPrices.availableCurrencies}
        mobileMenuAnchorEl={mobileMenuAnchorEl}
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuClose={onMobileMenuClose}
        localStoragePrefix={localStoragePrefix}
      />

      <TableRender tableData={tableData} />
      <MetaButton
        disabled={moreRowsAvailable[rangeIdx] <= 0}
        onClick={showMore}
        theme={theme}
        className={"button_show_more w-[96%] md:w-auto mr-[2%] ml-[2%] md:mr-0"}
      >
        {t("btn_SHOW_MORE")}
      </MetaButton>
    </div>
  )
}
